module.exports = __webpack_public_path__ + "img/9.c81f69ce.jpg";